import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import PlayButtonWithRipple from "../play_btn_with_ripple";
import { htmlParse } from "@unisearch/helpers";
import { getAssets } from "@unisearch/helpers";
import styles from "./about_unisearch_banner.module.scss";
import Image from "next/legacy/image";
import { useInView } from "react-intersection-observer";

const AboutUnisearchBanner = (props) => {
  // const [isOpen, setOpen] = useState(false);
  // const { ref, inView, entry } = useInView();
  // useEffect(() => {
  //   if (inView) {
  //     setOpen(true);
  //   } else {
  //     setOpen(false);
  //   }
  // }, [inView]);

  return (
    <div className={styles.wrapper}>
      <div className="container">
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent={"center"}
          className={styles.grid_container}
        >
          <Grid item xs={12} sm={12} md={8}>
            <div className={`${styles.left} text-center`}>
              {props.heading && (
                <h2 className={styles.heading}>{htmlParse(props.heading)}</h2>
              )}
              <p className={styles.sub_text}>{props.shortDescription}</p>
            </div>
          </Grid>

          {/* <Grid item xs={12} sm={12} md={6}>
            <div className={styles.right}>
              <div className={styles.video_wrapper}>
                <img
                  src={getAssets("assets/images/exam/ornaments.png")}
                  alt="ornaments"
                  className={styles.ornaments}
                />
                <img
                  src={getAssets("assets/images/exam/circle.png")}
                  alt="circle"
                  className={styles.circle}
                />
                <div className={styles.video_image_wrpper}>
                  <Image
                    layout="responsive"
                    width={577}
                    height={372}
                    blurDataURL={getAssets(
                      "assets/images/study/country_placeholder.webp"
                    )}
                    placeholder="blur"
                    src={getAssets("/assets/images/exam/library.webp")}
                    alt="library"
                  />
                </div>

                {isOpen && (
                  <div className={styles.iframe_video_wrapper}>
                    <iframe
                      src="https://www.youtube.com/embed/xkLBRlq-jpY?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1&loop=1"
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
                <div className={styles.ref} ref={ref}></div>
                <PlayButtonWithRipple onClick={() => setOpen(true)} />
              </div>
            </div>
          </Grid> */}
        </Grid>
      </div>
    </div>
  );
};

export default AboutUnisearchBanner;
